import languageSettings from "../../../../CommonVueCore/src/configs/language/languageSettings.json";

export default languageSettings;